import React from "react";
import StatusChart from "./StatusChart";
import Slider from "react-slick";
import ProductList from "./ProductList";
import OpeningList from "./OpeningList";
import ReactStars from "react-stars";

export default function AnalyticsReport({ Data, valueRating }) {
    console.log(Data, "Data_analytics");
    console.log(valueRating, "valueRating");

    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    // Calculate total points for each recruiter

    const calculateRecruiterPoints = (recruiter) => {
        return recruiter.shortList.reduce((total, analyticsItem) => {
            const ratingItem = valueRating.find(rating => rating.status_name === analyticsItem.status_name);
            if (ratingItem) {
                const points = analyticsItem.cnt * ratingItem.point_value;
                total += points;
            }
            return total;
        }, 0);
    };

    return (
        <div className="analytics-report">
            <Slider {...settings}>
                {Data.map((recruiterData, index) => {
                    const recruiterPoints = calculateRecruiterPoints(recruiterData);
                    const maxpoint = 100;
                    const recruiterRating = (recruiterPoints / maxpoint) * 5;
                    return (
                        <div key={index} className="analytics-slider">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-6 mb-3 mb-lg-0">
                                            <div className="d-flex align-items-center mb-3 gap-2 flex-wrap">
                                                <h6 className="dash-sub-head">{recruiterData.recruiter}</h6>
                                                {/* <h6>Total Points Earned: {recruiterRating}</h6> */}
                                                <ReactStars

                                                    count={5}
                                                    isHalf={true}
                                                    value={recruiterRating}
                                                    size={20}
                                                    activeColor="#ffd700"
                                                    edit={false}

                                                />

                                                <span style={{
                                                    color: recruiterRating >= 4 ? 'green' :
                                                        recruiterRating >= 2.5 ? 'yellow' :
                                                            'red'
                                                }}>
                                                    {recruiterRating.toFixed(1)}/ 5
                                                </span>
                                            </div>
                                            {recruiterData.jobopenings.map((job, index) => (
                                                <React.Fragment key={index}>
                                                    <h3 className="dash-sub01"> {job.openings} <span className="dash-sub-sub">(Target)</span></h3>
                                                    <p>{job.opening_summary}</p>
                                                </React.Fragment>
                                            ))}
                                        </div>

                                        {/* <div className="col-lg-4 col-md-6 mb-3 mb-lg-0">
                                            {recruiterData.shortList.map((job, index) => {
                                                let progressClass;
                                                if (job.status_name === "Closed") {
                                                    progressClass = ' bg-success';
                                                } else if (job.status_name === "Lost") {
                                                    progressClass = 'bg-danger';
                                                } else if (job.status_name === "Hold") {
                                                    progressClass = 'bg-warning';
                                                }
                                                return (
                                                    <div key={index} className='analytics-progress'>
                                                        <label>{job.status_name}</label>
                                                        <div className="progress">
                                                            <div className={`progress-bar ${progressClass}`} style={{ width: '100%' }}>
                                                                {job.cnt}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div> */}

                                        <div className="col-lg-4 col-md-6 mb-3 mb-lg-0">
                                            {recruiterData.shortList.map((job, index) => {
                                                let progressClass;
                                                let progressPercentage;

                                                if (job.status_name === "Recruit") {
                                                    progressClass = 'bg-success';
                                                    progressPercentage = (job.cnt / recruiterData.jobopenings[0].openings) * 100;
                                                } else if (job.status_name === "Reject") {
                                                    progressClass = 'bg-danger';
                                                    progressPercentage = (job.cnt / (2 * recruiterData.jobopenings[0].openings)) * 100;
                                                } else if (job.status_name === "On Hold") {
                                                    progressClass = 'bg-warning';
                                                    progressPercentage = (job.cnt / (2 * recruiterData.jobopenings[0].openings)) * 100;
                                                }

                                                return (
                                                    <div key={index} className='analytics-progress'>
                                                        <label>{job.status_name}</label>
                                                        <div className="progress">
                                                            <div className={`progress-bar ${progressClass}`} style={{ width: `${progressPercentage}%` }}>
                                                                {job.cnt}
                                                                {/* ({Math.round(progressPercentage)}%) */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>


                                        <div className="col-lg-4 col-md-12">
                                        <h4 className="dash-sub-head">Job Opening</h4>
                                            <StatusChart data1={recruiterData.shortList} Data={recruiterData.openingStatus} />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <ProductList Data={recruiterData.candidateList} />
                                        </div>
                                        <div className="col-md-6">
                                            <OpeningList Data={recruiterData.openingList} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Slider>
        </div>
    );
}
